import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category' },
  { name: '排行榜', path: '/category?sort=popular' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path.split('?')[0]);
  };

  return (
    <header className="relative z-50">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <span className="font-xiaowei text-2xl text-primary-500">
                布丁漫画
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                    isActive(link.path)
                      ? 'text-primary-500 bg-primary-100/70'
                      : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <button
                type="button"
                className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-500 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg" />
              </button>
              <button
                type="button"
                className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-500 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="书签"
              >
                <i className="ri-bookmark-line text-lg" />
              </button>
              <Link
                to="/about"
                className="px-5 py-2 bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
              </Link>
            </div>

            <button
              type="button"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-b border-background-200/70">
            <div className="px-4 py-3 flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                    isActive(link.path)
                      ? 'text-primary-500 bg-primary-100/70'
                      : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="flex items-center gap-2 pt-2 border-t border-background-200 mt-1">
                <button
                  type="button"
                  className="flex-1 py-2.5 text-sm font-medium text-foreground-600 hover:text-foreground-950 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-search-line mr-1" /> 搜索
                </button>
                <button
                  type="button"
                  className="flex-1 py-2.5 text-sm font-medium text-foreground-600 hover:text-foreground-950 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-bookmark-line mr-1" /> 收藏
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}